export function parseJwt(token: string): any {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

    const jsonPayload = decodeURIComponent(
        window
            .atob(base64)
            .split('')
            .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join(''),
    );

    return JSON.parse(jsonPayload);
}

const MIN_DECIMALS = 0;
export const MAX_DECIMALS = 2;
export function convertNumber(
    number: number | undefined,
    decimals: number | null = null,
    addPlusSign: boolean = false,
): string {
    if (!number && number !== 0) {
        return '';
    }
    const min_decimals = decimals ?? MIN_DECIMALS;
    const max_decimals = decimals ?? MAX_DECIMALS;
    const prefix: string = addPlusSign && number >= 0 ? '+' : '';
    // Use the right number of decimals and split the number in integer and decimals parts
    // Add a space every three digits
    let formattedNumber = number.toLocaleString('fr-FR', {
        minimumFractionDigits: min_decimals,
        maximumFractionDigits: max_decimals,
    });
    console.log(prefix + formattedNumber);

    return prefix + formattedNumber;
}

export function hexToRgba(hex: string, opacity: number): string {
    hex = hex.replace(/^#/, '');

    // Parse the hex values
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    // Ensure opacity is within the valid range [0, 1]
    const alpha = Math.max(0, Math.min(1, opacity));

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function formatSeconds(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(remainingSeconds).padStart(2, '0');

    return `${formattedMinutes}:${formattedSeconds}`;
}
